import React, { useRef } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleSpinner } from 'apps/auth/actions/appAction';
import FraudCvvPopup from 'apps/auth/components/antifraud/popups/FraudCvvPopup';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AF_VERIFYING_PAYMENT_CARD_SCREEN_PROMO_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SCENARIO_ID } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { ANTIFRAUD_CVV } from 'apps/auth/constants/formName';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const AntiFraudCvvCheck = (props) => {
    const messages = usePageMessages();
    const extra = useExtra();
    const form = useForm(ANTIFRAUD_CVV);
    const popupRef = useRef(null);

    const onContinueIntro = () => {
        amplitude.getInstance().logEvent(AF_VERIFYING_PAYMENT_CARD_SCREEN_PROMO_SHOWN, { [SCENARIO_ID]: extra.fraudScenarioId });
        popupRef.current?.open(
            <FraudCvvPopup popupRef={popupRef} cvvTitle={messages.cvvTitle} ticketId={extra.ticketId} payId={extra.payId} fields={form.fields} />,
        );
    };

    const onClickNotNow = () => {
        props.toggleSpinner(true);
        window.location.href = AUTH_SEND_MAIN_LINK;
    };

    return (
        <CommonPage>
            <InfoPage
                iconName="card-alert-80"
                iconColor="primary"
                headerText={<DangerouslyHtml dangerouslyHtml={messages.introHeaderTitle} />}
                secondaryText={<DangerouslyHtml dangerouslyHtml={messages.introText} />}
                primaryButtonCaption={messages.continueButton}
                topButtonCaption={messages.notNowButton}
                topButtonType="link"
                topButtonOnClick={onClickNotNow}
                primaryButtonOnClick={onContinueIntro}
            />
            <PopupNew ref={popupRef} />
        </CommonPage>
    );
};

export default connect(null, { toggleSpinner })(BasePage(AntiFraudCvvCheck));
